import { connectedStore } from '../../store';
import getBlock from '../selectors/block';
import getSupportedCategoriesForRegeneration from '../selectors/supported-categories-for-regeneration';
import getBlockVariations from '../selectors/block-variations';

const canBeRegenerated = (blockId, blockVariationId) => {
  const store = connectedStore.get();
  const state = store.getState();
  const block = getBlock(state, blockId);
  const supportedCategories = getSupportedCategoriesForRegeneration(state);
  let targetCategory = block.category;

  if (blockVariationId) {
    const variations = getBlockVariations(state, blockId);
    if (variations) {
      const variation = variations.find((item) => blockVariationId === item.id);

      // eslint-disable-next-line prefer-destructuring
      if (variation && variation.category) targetCategory = variation.category;
    }
  }

  return supportedCategories.includes(targetCategory);
};

export default canBeRegenerated;
